import { backendFetchCached } from './BackendApi.ts';
import { CredentialData } from '@/common/types';

export async function loadCredentials(): Promise<CredentialData[]> {
  return backendFetchCached<CredentialData[]>(
    '/credentials',
    {
      key: 'credentials_cache_v1',
      ttlMinutes: 24 * 60, // 24 hours
    },
    {
      credentials: 'include',
    }
  );
}
